import React, { PropsWithChildren } from 'react'
import { concatStyles } from 'utils'

export enum Size {
  default = 748,
  medium = 512,
  small = 384,
  xl = 1200,
  screen = '100vw',
}

const CONTAINER_STYLES =
  'flex bg-primary fixed top-0 left-0 w-screen h-screen m-0 overflow-auto sm:items-center z-50'
const FULL_OPACITY_BACKGROUND = 'bg-opacity-100'
const TRANSPARENT_OPACITY_BACKGROUND = 'bg-primary/50'
const LOADING_OPACITY = 'opacity-75'
const FULL_OPACITY = 'opacity-100'

export interface IContainerProps {
  transparent?: boolean
  loading?: boolean
  disabled?: boolean
  onClick?: () => void
}

export const Container: React.FC<PropsWithChildren<IContainerProps>> = ({
  transparent,
  loading,
  disabled,
  onClick: handleOnClick,
  children,
}) => (
  <article
    style={{ pointerEvents: loading || disabled ? 'none' : 'all' }}
    className={concatStyles([
      CONTAINER_STYLES,
      transparent ? TRANSPARENT_OPACITY_BACKGROUND : FULL_OPACITY_BACKGROUND,
      loading ? LOADING_OPACITY : FULL_OPACITY,
    ])}
    onClick={handleOnClick}
  >
    {children}
  </article>
)

const HEADING_STYLES = 'flex my-4 mx-auto text-contentareabackground'

export const Heading: React.FC<PropsWithChildren> = ({ children }) => (
  <header className={HEADING_STYLES}>{children}</header>
)

const CONTENT_REGION_STYLES =
  'flex flex-col relative xs:w-full xs:m-0 sm:w-9/12 sm:m-auto'

export interface IContentRegionProps {
  size?: Size
  onClick?: () => void
}

export const ContentRegion: React.FC<PropsWithChildren<
  IContentRegionProps
>> = ({ size, onClick: handleOnClick, children }) => (
  <div
    style={{ maxWidth: `${size}px`, pointerEvents: 'auto' }}
    className={CONTENT_REGION_STYLES}
    onClick={handleOnClick}
  >
    {children}
  </div>
)
